import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { TradeSettingsButton } from './trade-settings-button'

type Props = {
  value: boolean
  onChange: (value: boolean) => void
}

export const TradeSettingsSwitch: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Root>
      <TradeSettingsButton
        size="h36"
        radius="rounded"
        $enabled={value}
        disabled={value === true}
        onClick={() => onChange(!value)}
      >
        {t('common.enabled')}
      </TradeSettingsButton>
      <TradeSettingsButton
        size="h36"
        radius="rounded"
        $enabled={!value}
        disabled={value === false}
        onClick={() => onChange(!value)}
      >
        {t('common.disabled')}
      </TradeSettingsButton>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
`
